import { ReactNode } from 'react';

import styles from './InfoCard.module.scss';

type Props = {
  label: string;
  value: ReactNode;
  'data-testid'?: string;
};

export function InfoCard( { label, value, 'data-testid': dataTestId }: Props ) {
  return (
    <div className={ styles.card } data-testid={ dataTestId }>
      <p className={ styles.text }>
        <span className={ styles.label }>{ label }</span>
        <span className={ styles.value }>{ value }</span>
      </p>
    </div>
  );
}
